import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImagePreviewData {
  data: string;
  current: number;
}

@Component({
  selector: 'lohi-image-preview',
  styleUrls: ['image-preview.component.scss'],
  templateUrl: './image-preview.component.html',
})
export class ImagePreviewComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ImagePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImagePreviewData,
  ) {}

  public ngOnInit() {
    this.dialogRef.updateSize(`800px`, ``);
  }

  public downloadCurrentImage() {
    const link = document.createElement('a');
    link.href = this.data.data;
    const start = this.data.data.lastIndexOf('/') + 1;
    const end = this.data.data.indexOf('?') + 1 - start;
    link.download = `${this.data.data.substr(start, end)}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
